<template lang="pug">
  router-link.block.hover-text-app-text(:to="rt")
    figure.relative.pb-0.md-pb-full
      resp-img(v-if="image", :src="image.url", :alt="image.alt", imgClass="md-absolute inset-0 w-full h-full object-contain object-bottom")
      header.absolute.bottom-0.left-0.w-full.flex.justify-center.pb-15.lg-pb-10.px-5.text-13
        h4.min-w-160
          btn.btn-theme-outlined(theme="inherit", type="slim")
            slot
</template>

<script>
export default {
  name: 'ProductsCollectionThumb',
  props: ['image', 'rt']
}
</script>

<style>
</style>
